<span class="kt-font-success" *ngIf="priority === 1"> Low </span>
<span class="kt-font-warning" *ngIf="priority === 2"> Medium </span>
<span class="kt-font-danger" *ngIf="priority === 3"> High </span>